import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';

@Api('api/app/llm-configuration')
export class LLMConfigurationDto extends DtoHasApi {
  id: number;
  name: string;
  llmProviderName;
  apiKey: string;
  createdBy: string;
  lastModificationTime: Date;
  resourceName: string;
  apiVersion: string;
  deploymentName: string;
  tokenUri: string;
  generativeAIModel: string;
  reasoningEffort: string;
  llmProviderId: number;
}
